<template>
  <div>
    <nav-breadcrumb :menu="[{label: dealerId ? '编辑渠道商' : '新增渠道商'}]"/>

    <el-row>
      <el-col>
        <panel label="基本信息">
          <el-form :model="dealerForm" :rules="dealerFormRules" ref="dealerForm" label-width="150px">
          <el-row :gutter="10" class="bg-purple xamhtrpg">
              <el-col :span="12" v-if="dealerForm.d__dealerCode==''">
                <el-form-item label="渠道商编号：" style="width: 60%">
                  <el-input value="待生成" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="dealerForm.d__dealerCode!=''">
              <el-form-item label="渠道商编号：" style="width: 60%">
                <el-input v-model="dealerForm.d__dealerCode" disabled></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="渠道商名称：" prop="d__dealerName" style="width: 60%">
                <el-input v-model="dealerForm.d__dealerName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="渠道商等级：" prop="d__dealerTypeId" :rules="{required: true, message: '渠道商等级不能为空'}" style="width: 60%">
                <el-select placeholder="请选择渠道商等级" v-model.trim="dealerForm.d__dealerTypeId" >
                  <el-option :label="item.label" :value="item.value" v-for="(item,idx) in deviceTypeOptions" :key="idx"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="负责人：" prop="d__personInCharge" style="width: 60%">
                <el-input v-model="dealerForm.d__personInCharge"></el-input>
              </el-form-item>
            </el-col>
<!--            <el-col :span="24">-->
<!--              <el-form-item label="渠道商利率：" prop="d__interestRate" :rules="{required: true, message: '渠道利率不能为空'}" style="width: 90%">-->
<!--                <el-select placeholder="请选择渠道商利率" v-model.trim="dealerForm.d__interestType" >-->
<!--                  <el-option :label="item.label" :value="item.value" v-for="(item,idx) in interestTypeOptions" :key="idx"></el-option>-->
<!--                </el-select>-->
<!--                <el-input type="number" v-model.trim="dealerForm.d__interestRate" style="width: 15%"></el-input><span id="unit">%</span>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
              <el-col :span="12">
                  <el-form-item label="简码：" prop="d__prefix"  :rules="{required: true,max:5,min:1, message: '简码长度1-5'}" style="width: 60%">
                      <el-input v-model="dealerForm.d__prefix"></el-input>
                  </el-form-item>
              </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式：" prop="d__contactNo" style="width: 60%">
                <el-input v-model="dealerForm.d__contactNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态：" prop="d__disabled" :rules="{required: true, message: '状态不能为空'}">
                <el-select placeholder="请选择状态" v-model.trim="dealerForm.d__disabled" >
                  <el-option :label="item.label" :value="item.value" v-for="(item,idx) in disabledOptions" :key="idx"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
              <el-col :span="12">
                  <el-form-item label="是否助贷：" prop="d__forLender" style="width: 60%">
                      <el-checkbox  v-model="dealerForm.d__forLender" false-label="N" true-label="Y"></el-checkbox>
                  </el-form-item>
              </el-col>
          </el-row>
        </el-form>
        </panel>
      </el-col>
    </el-row>
    <div class="tr xzmt">
      <el-button type="primary" @click="onSubmit('dealerForm')">确认提交</el-button>
      <el-button @click="$router.back()">取消</el-button>
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  export default {
      name: "DealerAdd",
      data(){
          return {
            dealerId: this.$route.query['dealerId']||'',
            dealerForm:{
              d__disabled: 'N'
            },
            deviceTypeOptions : [],
            interestTypeOptions:[
              {
                label:'年利率',
                value:'Yearly'
              },
              {
                label:'月利率',
                value:'Monthly'
              },
              {
                label:'日利率',
                value:'Daily'
              }
            ],
            disabledOptions:[
              {
                label:'启用',
                value:'N'
              },
              {
                label:'禁用',
                value:'Y'
              },
            ],
            dealerFormRules: {},
          }
      },
      mounted() {
        if(this.dealerId){
          this.getData()
        }
        this.getDealerType()
      },
      methods:{
        getData:function(){
          xhr.getDealer({
              'd.dealerId': this.dealerId
            },
            res=> {
              try{
                if(res.data.status == 'success') {
                  this.dealerForm = res.data.data
                }
              }catch (e) {

              }
            })
        },
        getDealerType: function () {
          xhr.getDealerType(
            Object.assign({}, {}, {}),
            res=> {
              try {
                this.deviceTypeOptions = res.data.data.map(item=>{
                  return {
                    label: item.dt__name,
                    value:item.dt__dealerTypeId,
                  }
                })
              }catch(e){

              }
            })

        },
        onSubmit: function (formName) {
          let dealerForm = this.dealerForm
          this.$refs[formName].validate(valid=> {
            if (valid) {
              dealerForm.d__checked = true
              xhr.updateDealer(dealerForm, res=> {
                try {
                  if (res.data.status == 'success') {
                    this.$router.push({
                      name: 'DealerListView'
                    })
                  }
                } catch (e) {
                }
              })
            }
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/DealerAdd.vue